<template>
  <div class="maintenance-container">
    <h1>🚧 Site en maintenance 🚧</h1>
    <p>Notre site est momentanément indisponible pour cause de maintenance.<br>
      Merci de revenir dans quelques instants.</p>
  </div>
</template>

<script setup>

</script>

<style scoped>
.maintenance-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f6f6f8;
  color: #333;
  text-align: center;
}
h1 {
  font-size: 2.4rem;
  margin-bottom: 1.2rem;
}
</style>
